import request from '@/router/axios';

const baseUrl = "/ds_login"

// 用户名密码登录
export const login_by_username = (obj) => request({
    url: baseUrl+ '/admin_login_check',
    method: 'post',
    data: obj
});

// 根据 token 获得用户信息
export const get_userinfo = (params) => request({
    url: baseUrl+ '/setting/info',
    method: 'get',
    params: params
});

// 注册 参数： email password full_name yhlb organization research_group payment_method telephone invite_code
export const register = (obj) => request({
    url: baseUrl+ '/user/register',
    method: 'post',
    data: obj
});

// 更新个人资料（占位接口，待后端提供真实地址后替换 url）
// 参数：organization research_group payment_method telephone（按需传递）
export const update_user_profile = (obj) => request({
    url: baseUrl + '/admin/user/profile/update',
    method: 'post',
    data: obj
});

